import { forwardRef, useId } from 'react'
import { cn } from './cn'

export interface RangeProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
	label?: React.ReactNode
	/** Optional min/mid/max tick labels rendered below the track */
	ticks?: React.ReactNode[]
	hint?: React.ReactNode
	error?: React.ReactNode
}

export const Range = forwardRef<HTMLInputElement, RangeProps>(function Range(
	{ label, ticks, hint, error, className, id, ...rest },
	ref,
) {
	const generatedId = useId()
	const rangeId = id ?? generatedId
	return (
		<div className="w-full">
			{label && (
				<label htmlFor={rangeId} className="block text-xs opacity-70 mb-1">
					{label}
				</label>
			)}
			<input
				ref={ref}
				id={rangeId}
				type="range"
				className={cn('range-refined', className)}
				aria-invalid={error ? true : undefined}
				aria-describedby={error || hint ? `${rangeId}-help` : undefined}
				{...rest}
			/>
			{ticks && ticks.length > 0 && (
				<div className="flex justify-between text-[10px] opacity-80 px-1 mt-1">
					{ticks.map((tick, i) => (
						<span key={i}>{tick}</span>
					))}
				</div>
			)}
			{(error || hint) && (
				<p
					id={`${rangeId}-help`}
					role={error ? 'alert' : undefined}
					className={cn('text-xs mt-1', error ? 'text-error' : 'text-base-content/60')}
				>
					{error ?? hint}
				</p>
			)}
		</div>
	)
})
